module.exports = __webpack_public_path__ + "img/banner3.b6ace795.png";